import { render } from "./user_register.vue?vue&type=template&id=273f3733&scoped=true"
import script from "./user_register.vue?vue&type=script&lang=js"
export * from "./user_register.vue?vue&type=script&lang=js"

import "./user_register.vue?vue&type=style&index=0&id=273f3733&lang=scss"
import "./user_register.vue?vue&type=style&index=1&id=273f3733&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273f3733"]])

export default __exports__